import { StaffingRequestDetail } from "@/components/staffing-requests/StaffingRequestDetail";

interface Props {
  id: string;
}

export function StaffingRequestDetailPage({ id }: Props) {
  return <StaffingRequestDetail requestId={id} />;
}
